import React from "react";
import { Link } from "react-router-dom";
import "./Financialservices.css";
import { navigateToHomeSection } from '../utils/navigation';

const navLinks = [
  { label: "Services", href: "/#services" },
  { label: "Products", href: "/#products" },
  { label: "Industries", href: "/#industries" },
  { label: "Partners", href: "/#clients" },
  { label: "About", href: "/#about" },
  { label: "How We Work", href: "/#how-we-work" },
  { label: "Case Studies", href: "/#case-studies" },
  { label: "Contact Us", href: "/#contact" },
];
const footerLinks = [
  { label: "Services", href: "/#services" },
  { label: "Products", href: "/#products" },
  { label: "Industries", href: "/#industries" },
  { label: "Partners", href: "/#clients" },
  { label: "About", href: "/#about" },
  { label: "How We Work", href: "/#how-we-work" },
  { label: "Case Studies", href: "/#case-studies" },
  { label: "Contact Us", href: "/#contact" },
];

const metaCards = [
  { label: "SECTOR", value: "Financial Services" },
  { label: "FOCUS", value: "Risk · Ops · Customer" },
  { label: "MATURITY", value: "Production-grade" },
  { label: "COVERAGE", value: "EU & UK" },
];

const plays = [
  { id: "01", title: "Credit Risk & Scoring", desc: "IRB-aligned PD/LGD/EAD models and challenger ML models." },
  { id: "02", title: "Financial Crime", desc: "Transaction monitoring, KYC automation and adverse-media screening." },
  { id: "03", title: "Regulatory Reporting", desc: "Modern data platforms supporting BCBS 239 and granular reporting." },
  { id: "04", title: "Customer Analytics", desc: "Next-best-action, retention and personalised pricing." },
  { id: "05", title: "Model Risk Management", desc: "Independent validation and ongoing monitoring frameworks." },
  { id: "06", title: "Operations Automation", desc: "Intelligent automation for onboarding, claims and back-office processes." },
];

const phases = [
  { phase: "PHASE 01", title: "Assess", desc: "Map opportunities across risk, finance, ops and customer.", align: "left" },
  { phase: "PHASE 02", title: "Pilot", desc: "Prove value on a contained business problem with measurable KPIs.", align: "right" },
  { phase: "PHASE 03", title: "Industrialise", desc: "Deploy with model risk, security and resilience controls.", align: "left" },
  { phase: "PHASE 04", title: "Sustain", desc: "Embed monitoring, governance and continuous improvement.", align: "right" },
];

const outcomes = [
  { num: "/ 01", text: "Faster, more consistent credit and underwriting decisions" },
  { num: "/ 02", text: "Lower cost-to-serve through intelligent automation" },
  { num: "/ 03", text: "Stronger financial-crime detection with fewer false positives" },
  { num: "/ 04", text: "Defensible, regulator-ready AI under a robust MRM framework" },
];

const otherSectors = [
  { name: "Education", desc: "AI for higher education and learning", img: "education", link: "/education" },
  { name: "Energy & Utilities", desc: "AI for the energy transition", img: "energy", link: "/energy-utilities" },
  { name: "Healthcare", desc: "Trustworthy AI for clinical and operational excellence", img: "health", link: "/healthcare" },
];

export default function FinancialServices() {
  return (
    <div className="fsv-root">

      {/* ── HERO with city skyline bg ── */}
      <section className="fsv-hero">
        <nav className="fsv-nav">
          <div className="fsv-nav-inner">
            <div className="fsv-logo">
              <span className="fsv-logo-aiv">AIV</span><span className="fsv-logo-ion">ION</span>
            </div>
            <ul className="fsv-nav-links">
              {navLinks.map((l) => <li key={l.label}><a href={l.href} onClick={(e)=>{e.preventDefault(); navigateToHomeSection(l.href);}}>{l.label}</a></li>)}
            </ul>
            <a href="/#contact" className="fsv-contact-btn" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#contact');}}>CONTACT US</a>
          </div>
        </nav>

        <div className="fsv-hero-content">
          <p className="fsv-hero-breadcrumb">&#8592; INDUSTRIES</p>
          <div className="fsv-hero-sector">
            <span className="fsv-sector-icon">&#127974;</span>
            <span>SECTOR FOCUS</span>
          </div>
          <h1 className="fsv-hero-title">Financial Services</h1>
          <p className="fsv-hero-sub">AI for banking, lending and insurance</p>
        </div>
      </section>

      {/* ── META CARD ROW (overlapping hero/white) ── */}
      <div className="fsv-meta-wrap">
        <div className="fsv-meta-row">
          {metaCards.map((m) => (
            <div key={m.label} className="fsv-meta-card">
              <p className="fsv-meta-label">{m.label}</p>
              <p className="fsv-meta-value">{m.value}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── OPPORTUNITY SECTION ── */}
      <section className="fsv-opportunity">
        <div className="fsv-opportunity-inner">
          <div className="fsv-opp-left">
            <p className="fsv-eyebrow">THE OPPORTUNITY</p>
            <h2 className="fsv-opp-title">Where AI is changing Financial Services.</h2>
            <span className="fsv-opp-pill">&#9679; AIVION sector practice</span>
          </div>
          <div className="fsv-opp-right">
            <p className="fsv-dropcap-para">
              <span className="fsv-dropcap">A</span>IVION partners with banks, specialist lenders, asset managers and
              insurers to deploy AI inside the strict guardrails of financial regulation. From credit-risk modelling
              and anti-financial-crime through to actuarial analytics and customer experience, we deliver solutions
              that are explainable, well-governed and aligned to PRA, FCA and EBA expectations. Our work helps
              clients reduce cost, accelerate decisions and unlock entirely new propositions — without compromising
              on model risk management.
            </p>
            <blockquote className="fsv-quote">
              <span className="fsv-quote-mark">&#8220;</span>
              <p>AI for banking, lending and insurance</p>
              <cite>AIVION — FINANCIAL SERVICES PRACTICE</cite>
            </blockquote>
          </div>
        </div>
      </section>

      {/* ── SIX HIGH-IMPACT PLAYS ── */}
      <section className="fsv-plays">
        <div className="fsv-plays-inner">
          <div className="fsv-plays-header">
            <div>
              <p className="fsv-eyebrow">WHERE WE WORK</p>
              <h2 className="fsv-plays-title">Six high-impact plays</h2>
            </div>
            <span className="fsv-plays-count">06 AREAS</span>
          </div>
          <div className="fsv-plays-list">
            {plays.map((p) => (
              <div key={p.id} className="fsv-play-row">
                <span className="fsv-play-num">{p.id}</span>
                <h4 className="fsv-play-title">{p.title}</h4>
                <p className="fsv-play-desc">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ENGAGEMENT MODEL — ZIGZAG PHASES ── */}
      <section className="fsv-phases">
        <div className="fsv-phases-inner">
          <p className="fsv-eyebrow fsv-center">ENGAGEMENT MODEL</p>
          <h2 className="fsv-phases-title fsv-center">From assessment to lasting capability</h2>
          <div className="fsv-phases-track">
            {phases.map((ph) => (
              <div key={ph.phase} className={`fsv-phase-row fsv-phase-${ph.align}`}>
                <div className="fsv-phase-card">
                  <p className="fsv-phase-label">{ph.phase}</p>
                  <h4 className="fsv-phase-name">{ph.title}</h4>
                  <p className="fsv-phase-desc">{ph.desc}</p>
                </div>
                <span className="fsv-phase-dot" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── OUTCOMES (dark) ── */}
      <section className="fsv-outcomes">
        <div className="fsv-outcomes-inner">
          <p className="fsv-eyebrow">THE IMPACT</p>
          <h2 className="fsv-outcomes-title">Outcomes our Financial Services clients see.</h2>
          <div className="fsv-outcomes-grid">
            {outcomes.map((o) => (
              <div key={o.num} className="fsv-outcome-cell">
                <span className="fsv-outcome-num">{o.num}</span>
                <p>{o.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── OTHER SECTORS ── */}
      <section className="fsv-other-sectors">
        <div className="fsv-other-inner">
          <div className="fsv-other-header">
            <div>
              <p className="fsv-eyebrow">OTHER SECTORS</p>
              <h2 className="fsv-other-title">Across the industries we serve</h2>
            </div>
            <Link to="/industries" className="fsv-other-all">All industries &#8594;</Link>
          </div>
          <div className="fsv-other-grid">
            {otherSectors.map((s) => (
              <div key={s.name} className={`fsv-sector-card fsv-img-${s.img}`}>
                <div className="fsv-sector-img" />
                <div className="fsv-sector-info">
                  <p className="fsv-sector-tag">INDUSTRY</p>
                  <h4>{s.name}</h4>
                  <p className="fsv-sector-desc">{s.desc}</p>
                  <Link to={s.link} className="fsv-sector-explore">EXPLORE &#8594;</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BANNER (dark) ── */}
      <section className="fsv-cta">
        <div className="fsv-cta-inner">
          <div className="fsv-cta-left">
            <p className="fsv-eyebrow">START THE CONVERSATION</p>
            <h2 className="fsv-cta-title">Bring AIVION's Financial Services expertise to your team.</h2>
            <p className="fsv-cta-desc">
              A focused 30-minute briefing with one of our sector leads — exploring the highest-value AI plays for
              your business and how to get there safely.
            </p>
          </div>
          <div className="fsv-cta-right">
            <a href="/#contact" className="fsv-cta-btn-solid" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#contact');}}>REQUEST A SECTOR BRIEFING &#8594;</a>
            <button className="fsv-cta-btn-outline" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#case-studies');}}>SEE SECTOR CASE STUDIES</button>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="fsv-footer">
        <div className="fsv-footer-inner">
          <div className="fsv-footer-brand">
            <div className="fsv-footer-logo">
              <span className="fsv-logo-aiv">AIV</span><span className="fsv-logo-ion">ION</span>
            </div>
            <p>Delivering meaningful outcomes through intelligent AI solutions.</p>
            <div className="fsv-footer-icons">
              <span className="fsv-icon">in</span>
              <span className="fsv-icon">&#9993;</span>
            </div>
          </div>
          <div className="fsv-footer-col">
            <p className="fsv-footer-heading">QUICK LINKS</p>
            <div className="footer-quick-links-grid">
              {footerLinks.map((l) => <a key={l.label} href={l.href} className="fsv-footer-link" onClick={(e)=>{e.preventDefault(); navigateToHomeSection(l.href);}}>{l.label}</a>)}
            </div>
          </div>
        </div>
        <div className="fsv-footer-bottom">
          <p>&#169; 2026 AIVION. All rights reserved.</p>
          
        </div>
      </footer>

    </div>
  );
}
